import useTranslation from '@nvs/gatsby-theme-leap-core/src/hooks/useTranslation';
import React from 'react';
export const NovartisCopayPlusSVG: React.FC<{
	className?: string;
}> = ({ className }) => {
	const { t } = useTranslation();
	return (
		<>
			<span id="novartis-copay-plus" className="sr-only">
				{t('pages.novartis.copay.plus.img.alt')}
			</span>
			<svg
				width="121"
				height="45"
				viewBox="0 0 121 45"
				className={className}
				fill="currentColor"
				xmlns="http://www.w3.org/2000/svg">
				<path
					id="Path 6505"
					d="M0.580078 10.8612C0.580078 4.93118 4.45007 0.451172 10.3701 0.451172C12.6801 0.451172 14.6301 1.12117 16.0501 2.20117C17.7801 3.51117 18.7801 5.46117 19.0301 7.68117H14.1101C13.8601 5.90117 12.4701 4.54117 10.3501 4.54117C7.12007 4.54117 5.59007 7.24117 5.59007 10.8612C5.59007 14.5012 7.43007 17.1512 10.3801 17.1512C12.5801 17.1512 14.0201 15.7612 14.2501 13.8412H19.1701C19.0301 15.8212 18.1401 17.6212 16.7801 18.9312C15.2501 20.4012 13.2201 21.1812 10.4101 21.1812C4.56007 21.1812 0.580078 16.8112 0.580078 10.8612Z"
				/>
				<path
					id="Path 6506"
					d="M20.28 13.6416C20.28 9.35156 23.34 6.10156 27.9 6.10156C32.49 6.10156 35.5 9.35156 35.5 13.6416C35.5 17.9216 32.5 21.1815 27.9 21.1815C23.34 21.1815 20.28 17.9315 20.28 13.6416ZM30.91 13.6416C30.91 11.0516 29.85 9.30156 27.88 9.30156C25.9 9.30156 24.88 11.0516 24.88 13.6416C24.88 16.2316 25.91 17.9516 27.88 17.9516C29.85 17.9516 30.91 16.2316 30.91 13.6416Z"
				/>
				<path
					id="Path 6507"
					d="M36.8401 11.8008H44.4101V15.7008H36.8401V11.8008Z"
				/>
				<path
					id="Path 6508"
					d="M46.6301 0.841797H55.5901C58.0101 0.841797 59.7901 1.5118 61.0201 2.68179C62.3001 3.88179 63.0201 5.57179 63.0201 7.58179C63.0201 11.3918 60.3801 14.0918 56.2901 14.0918H51.6401V20.7418H46.6301L46.6301 0.841797ZM55.2801 10.1918C57.0601 10.1918 58.0601 9.13181 58.0601 7.5518C58.0601 5.9718 57.0301 4.99181 55.2801 4.99181H51.6401V10.1918H55.2801Z"
				/>
				<path
					id="Path 6509"
					d="M63.1301 16.7616C63.1301 13.6216 65.6301 12.6716 68.5801 12.2816C71.2501 11.9516 72.2001 11.6716 72.2001 10.6916C72.2001 9.77156 71.6201 9.16156 70.2501 9.16156C68.8001 9.16156 68.0801 9.80156 67.9401 11.0016H63.7701C63.8801 8.36156 65.9101 6.10156 70.2201 6.10156C72.3601 6.10156 73.8101 6.49156 74.8401 7.27156C76.0601 8.16156 76.6501 9.55156 76.6501 11.3316V18.5116C76.6501 19.6516 76.7601 20.2915 77.1501 20.5415V20.7316H72.7601C72.5401 20.4216 72.4001 19.8716 72.2901 19.1416H72.2301C71.4001 20.3416 70.1401 21.0916 68.0001 21.0916C65.1601 21.1015 63.1301 19.5715 63.1301 16.7616ZM72.3101 15.6416V13.9416C71.7301 14.2516 70.8901 14.4716 69.9701 14.6916C68.2201 15.0816 67.4901 15.5216 67.4901 16.6116C67.4901 17.7516 68.3201 18.2016 69.4401 18.2016C71.1501 18.2016 72.3101 17.1716 72.3101 15.6416Z"
				/>
				<path
					id="Path 6510"
					d="M79.0499 21.9002H80.6099C81.9499 21.9002 82.4699 21.3702 82.4699 20.4002C82.4699 19.7902 82.1899 18.9502 81.6099 17.4502L77.4099 6.49023H82.1999L84.1199 12.5602C84.5699 13.9502 85.0099 15.8402 85.0099 15.8402H85.0699C85.0699 15.8402 85.4599 13.9502 85.8999 12.5602L87.7599 6.49023H92.2999L87.3799 20.9302C86.2399 24.2702 84.8799 25.4402 82.0099 25.4402H79.0599V21.9002H79.0499Z"
				/>

				<path
					id="Path 6511"
					d="M28.9399 24.041H37.8999C40.3199 24.041 42.0999 24.711 43.3299 25.881C44.6099 27.081 45.3299 28.771 45.3299 30.781C45.3299 34.591 42.6899 37.291 38.5999 37.291H33.95V43.941H28.94L28.9399 24.041ZM37.59 33.391C39.3699 33.391 40.3699 32.331 40.3699 30.751C40.3699 29.161 39.34 28.191 37.59 28.191H33.95V33.391H37.59Z"
				/>
				<path
					id="Path 6512"
					d="M46.8301 24.041H51.4201V43.931H46.8301V24.041Z"
				/>
				<path
					id="Path 6513"
					d="M53.51 39.0416V29.6916H58.02V38.0916C58.02 39.6516 58.72 40.5116 60.16 40.5116C61.72 40.5116 62.66 39.3416 62.66 37.6416V29.6816H67.2V43.9316H62.86V42.1816H62.78C61.75 43.5717 60.5 44.3517 58.52 44.3517C55.24 44.3516 53.51 42.2116 53.51 39.0416Z"
				/>
				<path
					id="Path 6514"
					d="M68.51 39.3115H72.79C72.96 40.7315 73.9 41.4215 75.41 41.4215C76.77 41.4215 77.64 40.9215 77.64 40.0015C77.64 38.7215 75.91 38.5815 74.02 38.2515C71.54 37.8315 68.9 37.1715 68.9 33.8315C68.9 30.8315 71.68 29.2715 75.05 29.2715C79.08 29.2715 81.25 31.0215 81.48 33.8315H77.31C77.14 32.5515 76.28 32.1615 75.03 32.1615C73.92 32.1615 73.05 32.5815 73.05 33.4715C73.05 34.4715 74.66 34.6115 76.47 34.9415C78.97 35.3615 81.92 36.0015 81.92 39.6415C81.92 42.7615 79.17 44.3715 75.44 44.3715C71.26 44.3815 68.65 42.4615 68.51 39.3115Z"
				/>

				<path
					id="Path 6515"
					d="M84.54 38.8003C84.54 35.6803 86.38 33.3203 89.4 33.3203C92.42 33.3203 94.22 35.6903 94.22 38.8003C94.22 41.9203 92.42 44.2803 89.4 44.2803C86.38 44.2803 84.54 41.9203 84.54 38.8003ZM92.94 38.8003C92.94 36.3503 91.73 34.3703 89.4 34.3703C87.05 34.3703 85.84 36.3503 85.84 38.8003C85.84 41.2503 87.05 43.2303 89.4 43.2303C91.73 43.2403 92.94 41.2503 92.94 38.8003Z"
				/>
				<path
					id="Path 6516"
					d="M99.42 29.5811V30.6512H98.87C97.84 30.6512 97.51 31.0312 97.51 31.8412V33.5612H100.81V31.7012C100.81 30.1412 101.68 29.4512 103.26 29.4512C103.48 29.4512 103.71 29.4512 103.97 29.4712V30.5412H103.42C102.39 30.5412 102.06 30.9412 102.06 31.7312V33.5512H104V34.5812H102.06V44.0112H100.81V34.5812H97.51V44.0112H96.28V34.5812H94.76V33.5512H96.28V31.7912C96.28 30.2312 97.13 29.5412 98.71 29.5412C98.93 29.5612 99.15 29.5612 99.42 29.5811Z"
				/>
				<path
					id="Path 6517"
					d="M104.44 38.8003C104.44 35.6603 106.32 33.3203 109.22 33.3203C110.31 33.3203 111.22 33.6403 111.93 34.2303C113.2 35.2603 113.73 36.9003 113.71 39.0303H105.74C105.8 41.3803 106.93 43.2203 109.32 43.2203C111.06 43.2203 111.97 42.2903 112.38 40.8703H113.59C113.14 42.9303 111.67 44.2903 109.32 44.2903C106.18 44.2903 104.44 41.9403 104.44 38.8003ZM112.39 38.0303C112.33 35.9703 111.36 34.3503 109.21 34.3503C107.09 34.3503 105.97 35.9503 105.75 38.0303H112.39Z"
				/>
				<path
					id="Path 6518"
					d="M115.26 33.5605H116.51V35.5005H116.55C117.2 34.2905 118.29 33.4805 119.75 33.4805C119.91 33.4805 120.01 33.5005 120.09 33.5205V34.7505C119.34 34.6305 118.51 34.7905 117.86 35.2605C117.05 35.8705 116.5 36.8405 116.5 38.0705V44.0205H115.25V33.5605H115.26Z"
				/>
			</svg>
		</>
	);
};
